import { api } from "@/lib/api";

// Admin
export const adminListEnrollments = (params) =>
  api.get(`/admin/enrollments`, { params }).then((r) => r.data);
export const adminEnrollmentStats = () =>
  api.get(`/admin/enrollments/stats`).then((r) => r.data);
export const adminCreateEnrollment = (body) =>
  api.post(`/admin/enrollments`, body).then((r) => r.data);
export const adminUpdateEnrollment = (id, patch) =>
  api.put(`/admin/enrollments/${id}`, patch).then((r) => r.data);
export const adminDeleteEnrollment = (id) =>
  api.delete(`/admin/enrollments/${id}`).then((r) => r.data);
export const adminListStudentMappings = (studentId) =>
  api.get(`/admin/students/${studentId}/mappings`).then((r) => r.data);
export const adminListTeacherStudents = (teacherId) =>
  api.get(`/admin/teachers/${teacherId}/students`).then((r) => r.data);

// Teacher
export const teacherEnrollments = () =>
  api.get(`/teacher/enrollments`).then((r) => r.data);
export const teacherCourseEnrollments = (courseId) =>
  api.get(`/teacher/courses/${courseId}/enrollments`).then((r) => r.data);

// Student
export const studentEnrollments = () =>
  api.get(`/student/enrollments`).then((r) => r.data);
export const studentCourses = () =>
  api.get(`/student/courses`).then((r) => r.data);
export const studentCourseFull = (courseId) =>
  api.get(`/student/courses/${courseId}/full`).then((r) => r.data);

// ---- helpers ----

export const STATUS_LABELS = {
  mapped: "Mapped",
  awaiting_payment: "Awaiting payment",
  active: "Active",
  cancelled: "Cancelled",
};

export const PAYMENT_LABELS = {
  unpaid: "Unpaid",
  partial: "Partial",
  paid: "Paid",
};

export const PLAN_LABELS = {
  pay_in_full: "Pay in full",
  part_payment: "Part payment",
  monthly: "Monthly",
};

export const statusBadgeClass = (s) =>
  ({
    mapped: "bg-blue-50 text-blue-800 border-blue-300",
    awaiting_payment: "bg-amber-50 text-amber-900 border-amber-300",
    active: "bg-emerald-50 text-emerald-800 border-emerald-300",
    cancelled: "bg-zinc-100 text-zinc-600 border-zinc-300 line-through",
  }[s] || "bg-stone-100 text-stone-700 border-stone-300");

export const paymentBadgeClass = (s) =>
  ({
    unpaid: "bg-red-50 text-red-800 border-red-300",
    partial: "bg-amber-50 text-amber-900 border-amber-300",
    paid: "bg-emerald-50 text-emerald-800 border-emerald-300",
  }[s] || "bg-stone-100 text-stone-700 border-stone-300");

export const canEnterCourse = (e) =>
  e?.status !== "cancelled" &&
  (e?.payment_status === "paid" || e?.payment_status === "partial");

export const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
